module.exports = __webpack_public_path__ + "img/review-3.e4a88005.png";